function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.751 19.883l1.132-1.132a.4.4 0 000-.565L13.697 12l6.186-6.185a.4.4 0 000-.566l-1.132-1.132a.401.401 0 00-.565 0L12 10.303 5.815 4.117a.4.4 0 00-.566 0L4.117 5.249a.4.4 0 000 .565L10.303 12l-6.186 6.186a.4.4 0 000 .565l1.132 1.132a.4.4 0 00.565 0L12 13.697l6.186 6.186a.4.4 0 00.565 0z",
  fill: "#0082CA",
  fillRule: "evenodd"
});

function SvgCloseinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgCloseinline;